import api from "./api";

const paperWalletService = {
    get: (jwttoken) =>
        api.get(`/paper-wallet`, { 
            headers: { 'Authorization': `Basic ${jwttoken}` } 
        }),
    store: (jwttoken, data) =>
        api.post(`/paper-wallet`, data, { 
            headers: { 'Authorization': `Basic ${jwttoken}` } 
        }),
    getByCode: (jwttoken, code) =>
        api.get(`/paper-wallet/view/${code}`, { 
            headers: { 'Authorization': `Basic ${jwttoken}` } 
        }),
    updateValidationCode: (jwttoken, code, data) =>
        api.put(`/paper-wallet/updateValidationCode/${code}`, data, { 
            headers: { 'Authorization': `Basic ${jwttoken}` } 
        }),
    deposit: (jwttoken, code, data) =>
        api.post(`/paper-wallet/deposit/${code}`, data, { 
            headers: { 'Authorization': `Basic ${jwttoken}` } 
        }),
};

export default paperWalletService;